module.exports = __webpack_public_path__ + "img/ecoframe_logo.6ee2c442.png";